import React, { useCallback, useMemo, useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, FormGroup, Label, Input, Button, CustomInput } from "reactstrap"
import Cargando from 'components/Varios/Cargando'
import ButtonAceptar from 'components/Varios/Modals/ButtonAceptar'
import IconCloseModal from 'components/Varios/Modals/IconCloseModal'
import { FileInfo, FileInfoUrl } from 'components/Types/GeneralTypes'
import InputFileUpload from './InputFileUpload'

type PropsModalFirmarPDF = {
    show: boolean,
    urlArchivo: string,
    size: "xl" | "sm" | "md" | "lg",
    onClose: () => void,
    cargandoDatos: boolean,
    onClickFirma: (objeto: ObjetoFirmar) => Promise<void>,
    onClickFirmaFisica?: (objeto: ObjetoFirmar) => Promise<void>,
    tituloModal: string,
    extraData?: any,
    admiteFirmaFisica: boolean,
    classNameContentModal?: string,
}

type stateModalFirmar = {
    filesEnviar: FileInfoUrl[],
    contrasenia: string,
    firmandoDocumento: boolean,
    tipoFirma: "E" | "F" //"Electronica(Digital) o Fisica"
}

export type ObjetoFirmar = {
    extraData?: any,
    filesEnviar: FileInfoUrl[],
    contrasenia: string
}

export default function ModalFirmarPDF(props: PropsModalFirmarPDF) {
    const stateInicial: stateModalFirmar = {
        filesEnviar: [],
        contrasenia: "",
        firmandoDocumento: false,
        tipoFirma: "E"
    }
    const [stateModal, setstateModalFirmar] = useState<stateModalFirmar>(stateInicial)

    const ButtonAcept = useRef<HTMLButtonElement>();

    const ContenidoModalBody = useMemo(() => {
        if (props.cargandoDatos) {
            return (
                <Cargando />
            )
        }
        else if (!props.cargandoDatos && props.urlArchivo !== "") {
            return (
                <React.Fragment>
                    {/* <div style={{ overflowX: "auto" }} className=" objectPDF ow text-center mb-3"> */}
                    <div className={"containerPdfCertificadoHojaMarcacionVP"}>
                        <object data={props.urlArchivo}
                            type="application/pdf"
                            className='container-pdf mb-1'
                        >
                        </object>
                    </div>
                    <Row className="justify-content-center">
                        <CustomInput
                            className="col-md-3 col-sm-6 text-center"
                            type="radio"
                            checked={stateModal.tipoFirma === "E"}
                            id="firmaElectronica1"
                            onChange={() => setstateModalFirmar({ ...stateModal, tipoFirma: "E", filesEnviar: [] })}
                            label="Firmar electrónicamente"
                        />
                        {
                            props.admiteFirmaFisica &&
                            <CustomInput
                                className="col-md-3 col-sm-6 text-center"
                                type="radio"
                                id="firmaElectronica2"
                                checked={stateModal.tipoFirma === "F"}
                                onChange={() => setstateModalFirmar({ ...stateModal, tipoFirma: "F", filesEnviar: [] })}
                                label="Firmar físicamente"
                                disabled={!props.admiteFirmaFisica}
                            />
                        }
                    </Row>
                    {
                        stateModal.tipoFirma === "E" &&
                        <Row form className="mt-3">
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="nombremencion">Certificado*</Label>
                                    <InputFileUpload
                                        icon="upload"
                                        onChange={(archivo: FileInfo) => handleFileUploadChange(archivo)}
                                        name="DOC"
                                        id="CERT"
                                        placeholder="Subir firma electrónica"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="nombremencion">Contraseña*</Label>
                                    <Input
                                        type="password"
                                        name="contrasenia"
                                        id="contrasenia"
                                        placeholder=""
                                        onChange={(e) => handleChangeContra(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {
                        stateModal.tipoFirma === "F" && props.admiteFirmaFisica &&
                        <React.Fragment>
                            <Row form className="mt-3">
                                <Col md={12}>
                                    <InputFileUpload
                                        icon="upload"
                                        onChange={(archivo: FileInfo) => handleFileUploadChange(archivo)}
                                        name="DOC"
                                        id="CART"
                                        placeholder="Subir documento firmado físicamente"
                                    />
                                </Col>
                            </Row>
                            <Row className="ml-2 mt-2">
                                <span id="muted">
                                    Esta solicitud se hará efectiva, una vez que se entregue el documento original en la Unidad de Talento Humano
                                    <i className="fas fa-info-circle pl-2" aria-hidden="true" style={{ color: "red" }}></i>
                                </span>
                            </Row>
                        </React.Fragment>
                    }
                </React.Fragment>
            )
        }
        else {
            return (
                <div>
                    No hay contenido por mostrar
                </div>
            )
        }
    }, [props.urlArchivo, props.cargandoDatos, stateModal])

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal
                handleClickIcon={() => CerrarModal()}
            />
        )
    }
        , [props])

    const BotonFirmar = useMemo(() => {
        const { firmandoDocumento, filesEnviar, contrasenia, tipoFirma } = stateModal
        var objeto_pasando: ObjetoFirmar = {
            extraData: props.extraData,
            filesEnviar,
            contrasenia
        }

        var requiereContrasenia: boolean = (tipoFirma === "E" && contrasenia !== undefined && contrasenia !== "") || (tipoFirma === "F")

        const botonAceptar = document.getElementById("botonAceptar");
        const i_element = document.getElementById("loadingEnviar");

        if (firmandoDocumento && botonAceptar !== null && filesEnviar.length > 0 && requiereContrasenia) {
            const i = document.createElement("i");
            i.setAttribute("id", "loadingEnviar")
            i.setAttribute("class", "fa fa-spin fa-spinner")
            botonAceptar.textContent = "Firmando... "
            botonAceptar.insertBefore(i, null)
            botonAceptar.setAttribute("disabled", "true")

            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  >Firmar</Button>
            )
        }
        else if (!firmandoDocumento && botonAceptar !== null && i_element !== null && filesEnviar.length > 0 && requiereContrasenia) {
            i_element.remove();
            botonAceptar.setAttribute("disabled", "false")

            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  >Firmar</Button>
            )
        }
        else if (!firmandoDocumento && filesEnviar.length > 0 && requiereContrasenia) {
            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  >Firmar</Button>
            )
        }
    }
        , [stateModal, props.extraData])

    function handleFileUploadChange(archivo: FileInfo) {
        var uploadFile = new File([archivo.file], archivo.id + ".pdf");

        const src = window.URL.createObjectURL(uploadFile);

        const firmaArchivoInfo: FileInfoUrl = {
            nombreFile: archivo.nombreFile,
            file: uploadFile,
            id: archivo.id,
            url: src
        };

        setstateModalFirmar({
            ...stateModal,
            filesEnviar: [firmaArchivoInfo],
        })
    }

    function handleChangeContra(e: string) {
        var _contrasenia_ = new TextEncoder().encode(e).toString();
        setstateModalFirmar({ ...stateModal, contrasenia: _contrasenia_ })
    }

    const handleFirmar = useCallback(
        async (objetoFirmar: any) => {
            setstateModalFirmar({ ...stateModal, firmandoDocumento: true })
            if (stateModal.tipoFirma === "E") {
                await props.onClickFirma(objetoFirmar);
                document.body.classList.remove('modal-open');
            }
            else if (stateModal.tipoFirma === "F" && typeof (props.onClickFirmaFisica) === "function") {
                await props.onClickFirmaFisica(objetoFirmar);
            }
            setstateModalFirmar({ ...stateModal, firmandoDocumento: false })
        }
        , [stateModal])

    function CerrarModal() {
        setstateModalFirmar(stateInicial);
        props.onClose()
        document.body.classList.remove('modal-open');
    }

    const BotonCancelar = useMemo(() => {
        return (
            <Button color="secondary" id="botonCancelar" disabled={stateModal.firmandoDocumento} onClick={() => CerrarModal()}>Cancelar</Button>
        )
    }, [stateModal, props])
    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={true}
            onClosed={() => CerrarModal()}
            contentClassName="custom-modal-style"
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal}</div>
            </ModalHeader>
            <ModalBody className={props.classNameContentModal ?? ""}>
                {ContenidoModalBody}
            </ModalBody>
            <ModalFooter>

                {BotonFirmar}
                {BotonCancelar}
            </ModalFooter>
        </Modal>

    )
}